module.exports = __webpack_public_path__ + "static/givng-9bf0c81c03550c1b28b8c0ec772af942.png";